// page-about-us.jsx — 私たちについて (About Us)
// Issue #38 [HP改修] 私たちについて（/about-us/）再構成 に準拠。
// 採用関連 (CEO MESSAGE / OFFICE & TEAM) は /recruit/ に移動。
// セクション順: HERO → STATEMENT → VISION → SERVICES → PROCESS
//               → COLLABORATIONS → ACHIEVEMENTS → MEDIA → FACTS → END CTA

(function(){
  const { HBLayout, HBSubHero, hbcp, fontEN, fontENSans, fontJP, fontMono, HB_BASE } = window;
  const fontSerif = '"Zen Kaku Gothic New", "Noto Sans JP", sans-serif';

  // SERVICES — 4 専門領域
  const SERVICES = [
    {
      num:'01',
      en:'DX / BPR',
      jp:'DX システム導入 ・ BPR 支援',
      d:'kintone・Salesforce・会計ソフトの導入から、業務プロセス再設計 (BPR) まで内製チームで一貫対応。事業の意思決定スピードを上げる業務基盤を構築する。',
      url:`${HB_BASE}/hatena-dx/`,
      accent:'#1A4D4D',
    },
    {
      num:'02',
      en:'Accounting',
      jp:'経理業務改善 ・ 会計 AX 支援',
      d:'手作業の経理を、会計ソフト + BI で再設計。月次決算の高速化・管理会計・IPO 準備まで、経理・会計の実務専門家チームが伴走する。',
      url:`${HB_BASE}/hatena-account/`,
      accent:'#5C2B45',
    },
    {
      num:'03',
      en:'Hatena, Data',
      jp:'データサイエンス ／ AI・BI 支援',
      d:'仮説設計からビッグデータ探索・機械学習・BI レポーティングまで。「分析して終わり」ではなく、経営判断を動かすデータ基盤を構築する。',
      url:`${HB_BASE}/hatena-data/`,
      accent:'#1A3A6E',
    },
    {
      num:'04',
      en:'Training',
      jp:'DX・AI・会計 人材育成 ／ 速習研修',
      d:'速習 freee 会計研修・kintone 速習・生成 AI 業務適用研修。「使える人材」を組織に増やし、内側から業務変革を加速する。',
      url:`${HB_BASE}/training/`,
      accent:'#A65A38',
    },
  ];

  // PROCESS — 私たちの進め方
  const PROCESS = [
    { num:'01', en:'Listen',    jp:'初回ヒアリング',     d:'初回面談の前に、財務データ・業界構造・既存ツールの利用状況をリサーチ。仮説を持った状態でヒアリングに臨み、業務フローと課題を1〜2回の面談で構造化します。' },
    { num:'02', en:'Design',    jp:'要件定義・要求定義', d:'導入スコープ・費用・スケジュールを明記した提案書を提出。「何を・いつまでに・いくらで」を具体化し、曖昧な方針書では終わらせません。' },
    { num:'03', en:'Implement', jp:'実装・開発',         d:'freee・kintone・AIエージェント等の初期設定からワークフロー構築まで、自社チームが手を動かして実装。テスト運用を経て本番に切り替えます。' },
    { num:'04', en:'Grow',      jp:'保守・BPOサポート',  d:'月次定例で数字とフローを振り返り、業務量の変化や新たな課題に合わせて仕組みをアップデート。属人化しない運用体制を一緒につくります。' },
  ];

  const P = (window.HB_ASSETS||'')+'images/partners/';
  // COLLABORATIONS — パートナーロゴ
  const PARTNERS = [
    { name:'freee', img:P+'freee.svg' },
    { name:'サイボウズ', img:P+'cybozu.png' },
    { name:'LayerX', img:P+'layerx.svg' },
    { name:'マネーフォワード', img:P+'moneyforward.svg' },
    { name:'OBC', img:P+'obc.png' },
    { name:'Salesforce', img:P+'salesforce.jpg' },
    { name:'Zoho', img:P+'zoho.svg' },
    { name:'Snowflake', img:P+'snowflake.svg' },
    { name:'Zapier', img:P+'zapier.svg' },
    { name:'デジタルベース', img:P+'digitalbase.png' },
    { name:'日本システム技術', img:P+'nihon-system.png' },
  ];

  // COLLABORATION 詳細 (協業の中身を 3 件くらい紹介)
  const COLLAB_DETAILS = [
    { who:'フリー株式会社', tag:'業務パッケージ',  d:'kintone × freee で SES 業界・広告業界に特化した業務パッケージを共同制作。業界固有の業務フローを標準化し、現場運用に乗せる形で提供。' },
    { who:'フリー株式会社', tag:'共同研修開発',    d:'バーチャル環境での実務研修「速習 freee 会計研修」を共同開発・提供。会計実務人材の即戦力化を、e-learning + ハンズオン演習で実現。' },
    { who:'株式会社 MAIA',  tag:'実地研修 PoC',    d:'実地研修の PoC を実施し、全国のワーカー創出プログラムへ展開中。地方在住の人材にもクラウド会計スキルを届け、リモート環境で活躍できる体制を整備。' },
  ];

  // ACHIEVEMENTS — セミナー登壇 / プレスリリース
  const ACHIEVEMENTS = [
    { date:'2026.06', kind:'プレス',  title:'キャリア・マム、はてなベース・freee と連携し「速習 freee 会計研修（実地研修版）」の提供を開始', org:'PR TIMES', url:'https://prtimes.jp/main/html/rd/p/000000010.000168081.html' },
    { date:'2025.08', kind:'プレス',  title:'freee、一般社団法人 DIGITAL BASE と業務提携を開始（速習 freee 会計研修 β 版）',        org:'freee 株式会社', url:'https://corp.freee.co.jp/news/20250826freee_digitalbase.html' },
    { date:'',        kind:'セミナー', title:'【京都開催】クラウド会計 × Google Workspace × AI 活用セミナー（はてなベース・MAIA・freee 共催）', org:'freee 株式会社', url:'https://adv.freee.co.jp/seminar/kyoto-hatena' },
    { date:'',        kind:'セミナー', title:'クラウド会計 習得済み人材採用で実現する「育成コストゼロ」経営セミナー',                       org:'freee 株式会社', url:'https://adv.freee.co.jp/seminar/cloud-accounting-employment' },
  ];

  // MEDIA — メディア掲載 (thumbnail は任意)
  const MEDIA_ITEMS = [
    { date:'2026.02', media:'IT 経理 NEXT',      title:'kintone × freee で実現する「会計 DX」最新事例',         url:'#', thumbnail:null },
    { date:'2025.10', media:'WIRED Japan',       title:'AI 時代に問われる「使える人材」育成のリアル',             url:'#', thumbnail:null },
    { date:'2025.06', media:'日経 xTREND',       title:'バックオフィス内製化が経営に効く理由',                     url:'#', thumbnail:null },
  ];

  function AboutUsPage() {
    return (
      <HBLayout>
        {/* ───── 1. HERO (踏襲) ───── */}
        <HBSubHero
          crumb={`About / 私たちについて`}
          en="About us"
          jp={<span>会計とDXの知見で、<br/><span style={{color:hbcp.blue}}>CAO業務における非効率</span>を改善</span>}
          tag={'Accounting × DX, one team.'}
          lead={<span style={{display:'block', fontSize:13.5, lineHeight:2.05}}>
            コーポレート領域において、資金調達を担うCFOが“表舞台”なら、それを支えるCAO（最高管理責任者）は“縁の下の力持ち”として、これまで光が当たることは稀でした。<br/><br/>
            しかし、会社の血液である資金を次なる成長へ繋げるには、バックオフィスを単なる「管理」から、戦略的な「攻め」の基盤へと変革させる必要があります。<br/><br/>
            私たちはてなベースグループは、会計・税務・CRM構築のノウハウとDXを駆使し、CAO業務の非効率を根本から解決する集団です。<br/><br/>
            整理整頓されたデータに基づく意思決定情報の可視化。私たちは、最新テクノロジーと専門知識で成長企業の挑戦を支え、社会に不可欠な価値を提供していきます。
          </span>}
        />

        {/* 2. STATEMENT セクションは issue #41 により削除（代表メッセージは /recruit に集約） */}

        {/* ───── 3. VISION — 事業サイクル図 ───── */}
        <section style={{padding:'96px 32px', background:hbcp.paper, borderBottom:`1px solid ${hbcp.line}`}}>
          <div style={{maxWidth:1280, margin:'0 auto'}}>
            <div className="hb-section-head">
              <span className="hb-section-head-en">Vision</span>
              <span className="hb-section-head-jp">私たちが目指すもの</span>
            </div>
            <h2 style={{fontFamily:fontJP, fontWeight:900, fontSize:'clamp(24px, 2.6vw, 32px)', lineHeight:1.45, letterSpacing:'.04em', margin:'0 0 18px', color:hbcp.ink, maxWidth:880}}>
              会計チームとエンジニアチームが連携し、バックオフィスを一気通貫でアップデートする
            </h2>
            <p style={{fontSize:15, lineHeight:1.95, color:hbcp.inkSoft, margin:'0 0 48px', maxWidth:760}}>
              会計ソフトの導入から CRM の構築・ツール間連携、会計 BI、業務フローの統一までを 1 つのチームで担い、お客様のバックオフィスを成長エンジンへと変えていきます。
            </p>

            {/* サービス全体像（差し替え画像 — issue #41） */}
            <div style={{maxWidth:1000, margin:'0 auto'}}>
              <img src={(window.HB_ASSETS||'')+"images/about_us/service-cycle-2026.png"} alt="はてなベースのサービス全体像。会計ソフトの導入・連携、kintone 等 CRM の構築・ツール間連携、会計 BI、業務フローの統一を一気通貫で提供する循環図。" style={{width:'100%', height:'auto', display:'block'}}/>
            </div>
          </div>
        </section>

        {/* ───── 4. SERVICES — 4 専門領域 ───── */}
        <section style={{padding:'96px 32px', background:hbcp.white, borderBottom:`1px solid ${hbcp.line}`}}>
          <div style={{maxWidth:1280, margin:'0 auto'}}>
            <div className="hb-section-head">
              <span className="hb-section-head-en">Services</span>
              <span className="hb-section-head-jp">4 つの専門領域</span>
            </div>
            <p style={{fontSize:14, lineHeight:1.95, color:hbcp.inkSoft, margin:'0 0 36px', maxWidth:680}}>
              4 つの専門領域を 1 つのチームが担います。DX・会計・データ・研修の知見がひとつのチームに宿るからこそ、「この機能は会計的にどう影響するか」「そのデータはAIで活用できないか」という問いを一貫して持ちながら伴走できます。
            </p>
            <div className="hb-about-services-grid" style={{display:'grid', gridTemplateColumns:'repeat(4, 1fr)', gap:16}}>
              {SERVICES.map( s => (
                <div key={s.num} style={{
                  display:'flex', flexDirection:'column', color:hbcp.ink,
                  padding:'28px 26px 24px', minHeight:380,
                  background:s.accent, borderTop:`3px solid ${s.accent}`,
                }}>
                  <div style={{display:'flex', alignItems:'baseline', gap:14, marginBottom:18, color:'rgba(255,255,255,.85)'}}>
                    <span style={{fontFamily:fontENSans, fontWeight:700, fontSize:34, color:'#fff', lineHeight:1}}>{s.num}</span>
                    <span style={{fontFamily:fontENSans, fontSize:11, letterSpacing:'.28em', fontWeight:700}}>{s.en.toUpperCase()}</span>
                  </div>
                  <h3 style={{fontFamily:fontJP, fontWeight:700, fontSize:'clamp(18px, 1.6vw, 22px)', lineHeight:1.4, letterSpacing:'.04em', margin:'0 0 14px', color:'#fff'}}>{s.jp}</h3>
                  <p style={{fontSize:13, lineHeight:1.85, color:'rgba(255,255,255,.9)', margin:0, flex:1}}>{s.d}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ───── 5. PROCESS — 私たちの進め方 ───── */}
        <section style={{padding:'96px 32px', background:hbcp.paper, borderBottom:`1px solid ${hbcp.line}`}}>
          <div style={{maxWidth:1280, margin:'0 auto'}}>
            <div className="hb-section-head">
              <span className="hb-section-head-en">Process</span>
              <span className="hb-section-head-jp">サービスご提供までの流れ</span>
            </div>
            {/* 縦に矢印で繋ぐレイアウト（issue#41追加-5） */}
            <div style={{maxWidth:760, margin:'0 auto'}}>
              {PROCESS.map( (p, i) => (
                <React.Fragment key={p.num}>
                  <div style={{padding:'30px 34px', background:'#fff', border:`1px solid ${hbcp.line}`, display:'flex', gap:28, alignItems:'flex-start'}}>
                    <div style={{flex:'0 0 auto', textAlign:'center'}}>
                      <div style={{fontFamily:fontENSans, fontWeight:700, fontSize:34, color:hbcp.blue, lineHeight:1}}>{p.num}</div>
                      <div style={{fontFamily:fontENSans, fontSize:10, letterSpacing:'.22em', fontWeight:700, color:hbcp.inkLight, marginTop:6}}>{p.en.toUpperCase()}</div>
                    </div>
                    <div>
                      <h3 style={{fontFamily:fontJP, fontWeight:700, fontSize:18, letterSpacing:'.04em', margin:'0 0 10px'}}>{p.jp}</h3>
                      <p style={{fontSize:13.5, lineHeight:1.95, color:hbcp.inkSoft, margin:0}}>{p.d}</p>
                    </div>
                  </div>
                  {i < PROCESS.length - 1 && (
                    <div style={{textAlign:'center', padding:'10px 0', color:hbcp.blue, fontSize:22, fontWeight:700, lineHeight:1}}>↓</div>
                  )}
                </React.Fragment>
              ))}
            </div>
          </div>
        </section>

        {/* ───── 6. COLLABORATIONS — パートナー 11 社 ───── */}
        <section style={{padding:'96px 32px', background:hbcp.white, borderBottom:`1px solid ${hbcp.line}`}}>
          <div style={{maxWidth:1280, margin:'0 auto'}}>
            <div className="hb-section-head">
              <span className="hb-section-head-en">Collaborations</span>
              <span className="hb-section-head-jp">協業パートナー</span>
            </div>
            <p style={{fontSize:15, lineHeight:1.95, color:hbcp.inkSoft, margin:'0 0 36px', maxWidth:880}}>
              会計ベンダー様、自治体コンテンツベンダー様と協業し、AX・BPR の事例を貯めつつコンテンツに昇華しながら、全国の DX 人材・経理人材の育成に努めてまいります。
            </p>

            {/* ロゴグリッド */}
            <div className="hb-about-collab-grid" style={{display:'grid', gridTemplateColumns:'repeat(6, 1fr)', gap:0, borderTop:`1px solid ${hbcp.line}`, borderLeft:`1px solid ${hbcp.line}`, marginBottom:48}}>
              {PARTNERS.map( p => (
                <div key={p.name} style={{
                  height:120, borderRight:`1px solid ${hbcp.line}`, borderBottom:`1px solid ${hbcp.line}`,
                  display:'flex', alignItems:'center', justifyContent:'center',
                  padding:'12px 20px', background:'#fff', overflow:'hidden',
                }}>
                  {p.img ? (
                    <img src={p.img} alt={p.name} style={{maxWidth:'100%', maxHeight:64, width:'auto', height:'auto', objectFit:'contain', display:'block', filter: p.name==='Zoho' ? 'none' : 'grayscale(.15)'}}/>
                  ) : (
                    <span style={{fontFamily:fontJP, fontSize:14, fontWeight:700, color:hbcp.inkSoft, textAlign:'center'}}>{p.name}</span>
                  )}
                </div>
              ))}
            </div>
            <p style={{fontFamily:fontJP, fontSize:11, lineHeight:1.7, color:hbcp.inkLight, margin:'-36px 0 48px'}}>The Zoho logo is a registered trademark of Zoho Corporation.</p>

            {/* 主要協業 3 件の中身 */}
            <h3 style={{fontFamily:fontJP, fontSize:18, fontWeight:700, margin:'0 0 18px', letterSpacing:'.04em'}}>これまでの協業の事例</h3>
            <div style={{borderTop:`1px solid ${hbcp.ink}`}}>
              {COLLAB_DETAILS.map( (c, i) => (
                <div key={i} className="hb-about-collab-detail" style={{display:'grid', gridTemplateColumns:'200px 140px 1fr', gap:32, alignItems:'center', padding:'22px 0', borderBottom:`1px solid ${hbcp.line}`}}>
                  <div style={{fontFamily:fontJP, fontWeight:700, fontSize:16, color:hbcp.ink, letterSpacing:'.04em'}}>{c.who}</div>
                  <div style={{fontFamily:fontJP, fontSize:11, fontWeight:700, color:hbcp.blue, padding:'6px 10px', border:`1px solid ${hbcp.blue}`, justifySelf:'start'}}>{c.tag}</div>
                  <div style={{fontSize:13.5, lineHeight:1.85, color:hbcp.inkSoft}}>{c.d}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ───── 7. ACHIEVEMENTS — セミナー登壇・プレス ───── */}
        <section style={{padding:'96px 32px', background:hbcp.paper, borderBottom:`1px solid ${hbcp.line}`}}>
          <div style={{maxWidth:1280, margin:'0 auto'}}>
            <div className="hb-section-head">
              <span className="hb-section-head-en">Achievements</span>
              <span className="hb-section-head-jp">セミナー登壇 ／ プレス実績</span>
            </div>
            <p style={{fontSize:14, lineHeight:1.95, color:hbcp.inkSoft, margin:'0 0 32px', maxWidth:680}}>
              業界イベントへの登壇、プレスリリースを通じて、ナレッジを業界に還元しています。
            </p>
            <div style={{borderTop:`1px solid ${hbcp.ink}`}}>
              {ACHIEVEMENTS.map( (a, i) => (
                <a key={i} href={a.url} target="_blank" rel="noopener" className="hb-about-achievements-row" style={{display:'grid', gridTemplateColumns:'90px 110px 1fr 220px', gap:24, alignItems:'center', padding:'18px 0', borderBottom:`1px solid ${hbcp.line}`, textDecoration:'none', color:'inherit'}}>
                  <span style={{fontFamily:fontMono, fontSize:12, color:hbcp.inkLight}}>{a.date}</span>
                  <span style={{fontFamily:fontJP, fontSize:10.5, fontWeight:700, color:hbcp.blue, padding:'4px 8px', border:`1px solid ${hbcp.blue}`, justifySelf:'start'}}>{a.kind}</span>
                  <span style={{fontFamily:fontJP, fontSize:14, fontWeight:600, color:hbcp.ink, letterSpacing:'.04em'}}>{a.title}</span>
                  <span style={{fontFamily:fontJP, fontSize:12, color:hbcp.inkSoft, display:'inline-flex', alignItems:'center', gap:6}}>{a.org}<span style={{fontFamily:fontENSans, fontSize:13, color:hbcp.blue}}>↗</span></span>
                </a>
              ))}
            </div>
          </div>
        </section>

        {/* 8. MEDIA セクションは issue #41 により非表示（登壇・プレス実績へ統合・正確な4件のみ掲載） */}
        {false && (
        <section style={{padding:'96px 32px', background:hbcp.white, borderBottom:`1px solid ${hbcp.line}`}}>
          <div style={{maxWidth:1280, margin:'0 auto'}}>
            <div className="hb-section-head">
              <span className="hb-section-head-en">Media</span>
              <span className="hb-section-head-jp">メディア掲載</span>
            </div>
            <p style={{fontSize:14, lineHeight:1.95, color:hbcp.inkSoft, margin:'0 0 32px', maxWidth:680}}>
              外部メディアでの掲載実績の一部をご紹介します。
            </p>
            <div className="hb-about-media-grid" style={{display:'grid', gridTemplateColumns:'repeat(3, 1fr)', gap:20}}>
              {MEDIA_ITEMS.map( (m, i) => (
                <a key={i} href={m.url} target="_blank" rel="noopener" style={{
                  display:'flex', flexDirection:'column', gap:0,
                  background:hbcp.paper, border:`1px solid ${hbcp.line}`, borderTop:`3px solid ${hbcp.blue}`,
                  textDecoration:'none', color:hbcp.ink, overflow:'hidden',
                }}>
                  {m.thumbnail && (
                    <div style={{aspectRatio:'16/9', overflow:'hidden', background:hbcp.line}}>
                      <img src={m.thumbnail} alt={m.title} loading="lazy" style={{width:'100%', height:'100%', objectFit:'cover', display:'block'}}/>
                    </div>
                  )}
                  <div style={{padding:'20px 22px', display:'flex', flexDirection:'column', gap:10, flex:1}}>
                    <div style={{display:'flex', alignItems:'baseline', justifyContent:'space-between'}}>
                      <span style={{fontFamily:fontMono, fontSize:11, color:hbcp.inkLight}}>{m.date}</span>
                      <span style={{fontFamily:fontENSans, fontSize:14, color:hbcp.blue}}>↗</span>
                    </div>
                    <div style={{fontFamily:fontJP, fontSize:11, fontWeight:700, color:hbcp.blue, letterSpacing:'.04em'}}>{m.media}</div>
                    <h3 style={{fontFamily:fontJP, fontSize:14.5, fontWeight:700, lineHeight:1.6, letterSpacing:'.04em', margin:0, color:hbcp.ink, flex:1}}>{m.title}</h3>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </section>
        )}

        {/* ───── 9. FACTS — 会社情報 ───── */}
        <section style={{padding:'96px 32px', background:hbcp.paper}}>
          <div style={{maxWidth:1080, margin:'0 auto'}}>
            <div className="hb-section-head">
              <span className="hb-section-head-en">Profile</span>
              <span className="hb-section-head-jp">会社情報</span>
            </div>
            <div className="hb-about-facts-main" style={{display:'grid', gridTemplateColumns:'1fr 380px', gap:48, alignItems:'start', marginTop:14}}>
              <div className="hb-about-profile-grid" style={{borderTop:`1px solid ${hbcp.line}`}}>
                {[
                  ['会社名',     'はてなベース株式会社'],
                  ['代表',       '代表取締役 世戸口 逸人'],
                  ['設立',       '2023 年 2 月'],
                  ['本社所在地', '東京都新宿区愛住町 23-1 woody21 6 階'],
                  ['京都支店',   '京都市中京区河原町通御池下る下丸屋町390番地2'],
                  ['電話',       '03-4500-2647'],
                  ['メール',     'info@hatenabase.com'],
                  ['事業内容',   'バックオフィスBPR ／ 会計業務のAX化支援 ／ DX人材の育成'],
                  ['グループ',   'はてなベース株式会社 ／ はてなベース税理士法人 ／ はてなベース社会保険労務士事務所'],
                ].map(([k,v],i) => (
                  <div key={i} style={{display:'flex', gap:18, padding:'16px 0', borderBottom:`1px solid ${hbcp.line}`}}>
                    <span style={{fontFamily:fontJP, fontSize:11, color:hbcp.blue, fontWeight:700, width:110, flex:'0 0 110px'}}>{k}</span>
                    <span style={{fontSize:14, color:hbcp.ink, fontWeight:500, lineHeight:1.7}}>{v}</span>
                  </div>
                ))}
              </div>
              <figure style={{margin:0, position:'sticky', top:96}}>
                <div style={{aspectRatio:'4/3', overflow:'hidden', background:hbcp.line, border:`1px solid ${hbcp.line}`}}>
                  <img src={(window.HB_ASSETS||'')+'images/facts/facts-overview.jpg'} alt="はてなベース オフィス（四谷三丁目本社）" loading="lazy" style={{width:'100%', height:'100%', objectFit:'cover', display:'block'}}/>
                </div>
                <figcaption style={{marginTop:10, fontFamily:fontJP, fontSize:11.5, color:hbcp.inkSoft, lineHeight:1.6}}>はてなベース株式会社 オフィス</figcaption>
              </figure>
            </div>
            {/* Workplace gallery — 16:9 x3 */}
            <div className="hb-about-facts-gallery" style={{display:'grid', gridTemplateColumns:'repeat(3, 1fr)', gap:18, marginTop:48}}>
              {[
                {src:(window.HB_ASSETS||'')+'images/office/office-dual-monitor.jpg', alt:'執務の様子', cap:'執務の様子'},
                {src:(window.HB_ASSETS||'')+'images/facts/facts-all-hands.jpg',  alt:'全社集合写真',             cap:'メンバー集合 (全社イベント)'},
                {src:(window.HB_ASSETS||'')+'images/facts/facts-meeting.jpg',    alt:'チーム発表会',             cap:'社内ミーティング・発表会の様子'},
              ].map(p => (
                <figure key={p.src} style={{margin:0}}>
                  <div style={{aspectRatio:'16/9', overflow:'hidden', background:hbcp.paper, border:`1px solid ${hbcp.line}`}}>
                    <img src={p.src} alt={p.alt} loading="lazy" style={{width:'100%', height:'100%', objectFit:'cover', display:'block'}}/>
                  </div>
                  <figcaption style={{marginTop:10, fontFamily:fontJP, fontSize:11.5, color:hbcp.inkSoft, lineHeight:1.6}}>{p.cap}</figcaption>
                </figure>
              ))}
            </div>
          </div>
        </section>

        {/* ───── 10. CONTACT FORM ── Issue #13 により削除（お問い合わせ導線は下部の青背景 End CTA に集約） ───── */}

        {/* ───── End CTA (青背景) ───── */}
        <section style={{padding:'88px 32px', background:hbcp.blue, color:'#fff', position:'relative', overflow:'hidden'}}>
          <div style={{position:'relative', maxWidth:1280, margin:'0 auto', display:'grid', gridTemplateColumns:'1.4fr 1fr', gap:64, alignItems:'flex-end'}}>
            <div>
              <div style={{fontFamily:fontENSans, fontSize:11, letterSpacing:'.32em', opacity:.85, marginBottom:18}}>● CONTACT</div>
              <h2 style={{fontFamily:fontJP, fontWeight:900, fontSize:'clamp(30px, 3.6vw, 44px)', lineHeight:1.25, margin:'0 0 18px'}}>
                お気軽にお問い合わせください
              </h2>
              <p style={{fontSize:15, lineHeight:1.95, opacity:.9, margin:0, maxWidth:540}}>
                お問い合わせフォームからお気軽にどうぞ。お話を伺ったうえで、適切なチームメンバーから返信します。
              </p>
            </div>
            <div style={{display:'grid', gap:14}}>
              <a href={`${HB_BASE}/contact`} data-cv-track="true" style={{padding:'18px 28px', background:'#fff', color:hbcp.blue, textDecoration:'none', fontFamily:fontJP, fontSize:15, fontWeight:700, display:'flex', justifyContent:'space-between', alignItems:'center'}}>
                <span>お問い合わせ</span><span>→</span>
              </a>
              <a href={`${HB_BASE}/recruit`} style={{padding:'18px 28px', background:'transparent', color:'#fff', border:'1px solid rgba(255,255,255,.6)', textDecoration:'none', fontFamily:fontJP, fontSize:15, fontWeight:600, display:'flex', justifyContent:'space-between', alignItems:'center'}}>
                <span>採用情報を見る</span><span>↗</span>
              </a>
            </div>
          </div>
        </section>

        {/* ===== About Us mobile responsive overrides =====
            ページ全体で多用している inline grid (1fr 220px / repeat(3-6,1fr) / 200px 140px 1fr / 90px 110px 1fr 200px) が
            モバイルでも維持されて文字が縦書き化・列ハミ出し等で読めなくなっていた。
            section 単位で全 grid を 1fr に collapse + 縦書き化していたタイトルを横書きに戻す。 */}
        <style>{`
          @media (max-width: 760px) {
            /* Statement / Services / Process / Collab-detail / Achievements / Media / Profile を 1col 化 */
            .hb-about-statement-grid,
            .hb-about-services-grid,
            .hb-about-process-grid,
            .hb-about-collab-detail,
            .hb-about-achievements-row,
            .hb-about-media-grid,
            .hb-about-profile-grid {
              grid-template-columns: 1fr !important;
              gap: 16px !important;
            }
            /* FACTS gallery: 3 col → 1 col on mobile */
            .hb-about-facts-gallery {
              grid-template-columns: 1fr !important;
              gap: 16px !important;
              margin-top: 32px !important;
            }
            /* FACTS main: info + photo → 1 col on mobile */
            .hb-about-facts-main {
              grid-template-columns: 1fr !important;
              gap: 32px !important;
            }
            /* Vision (DX/AI/会計 3 カード) は 3 → 1 col 化、Collab logos は 6 → 3 col に */
            .hb-about-vision-grid {
              grid-template-columns: 1fr !important;
              gap: 0 !important;
            }
            /* variant-d-loader.php の汎用 div[style*="repeat(N, 1fr)"] override より
               specificity を上げるため html prefix。collab ロゴは 3col 維持。 */
            html .hb-about-collab-grid[style] {
              grid-template-columns: repeat(3, 1fr) !important;
              gap: 0 !important;
            }
            /* ロゴセル内 padding を mobile 用に圧縮 */
            .hb-about-collab-grid > * {
              padding: 16px !important;
              min-height: 80px !important;
            }
            .hb-about-collab-grid > * img {
              max-height: 36px !important;
              width: auto !important;
            }
            /* hb-section-head (eyebrow + jp + count) を縦積みに (PC では横並びで設計されている) */
            section .hb-section-head {
              flex-direction: column !important;
              align-items: flex-start !important;
              gap: 6px !important;
            }
            section .hb-section-head .hb-section-head-en,
            section .hb-section-head .hb-section-head-jp {
              writing-mode: horizontal-tb !important;
              white-space: normal !important;
              margin-left: 0 !important;
            }
            /* Statement section の jp title (HBChars 縦書きアニメ等) を横書きに矯正 */
            .hb-about-statement-grid .hb-section-head-jp { font-size: 26px !important; line-height: 1.35 !important; }
            /* Achievements / Collab-detail 行内: 各セルが grid 列扱いだが mobile では 1col + auto wrap */
            .hb-about-achievements-row > *,
            .hb-about-collab-detail > * {
              grid-column: 1 / -1 !important;
              justify-self: start !important;
            }
          }
        `}</style>
      </HBLayout>
    );
  }

  Object.assign(window, { AboutUsPage });
})();
